// Function to create an article card element
function createArticleCard(article) {
    console.log('Creating card for article:', article.title, 'with date:', article.date);
    // Handle missing images
    const imageHtml = article.image 
        ? `<img src="${article.image}" alt="${article.title}">` 
        : `<div class="placeholder-image"><i class="fas fa-newspaper"></i></div>`;
    
    // Convert category to lowercase for CSS class
    const categoryClass = article.category.toLowerCase().replace(/\s+/g, '-');
    
    return `
        <div class="article-card">
            <div class="card-header">
                <div class="card-category ${categoryClass}">${article.category}</div>
                <div class="card-date">${article.date}</div>
            </div>
            <div class="card-image">
                ${imageHtml}
            </div>
            <h3>${article.title}</h3>
            <p>${article.description}</p>
            <div class="card-footer">
                <a href="${article.url}" class="read-more">Read Full Analysis <i class="fas fa-arrow-right"></i></a>
            </div>
        </div>
    `;
}

// Function to filter articles based on category
function filterArticles(articles, category) {
    if (category === 'all') return articles;
    return articles.filter(article => article.category.toLowerCase() === category.toLowerCase());
}

// Function to load and display articles
async function loadArticles() {
    console.log('Starting to load articles...');
    const grid = document.querySelector('.feed-grid');
    if (!grid) {
        console.error('Feed grid element not found');
        return;
    }

    // Show loading state
    grid.innerHTML = '<div class="loading">Loading articles...</div>';

    try {
        // Use relative path to article registry with multiple cache-busting parameters
        const timestamp = new Date().getTime();
        const random = Math.random();
        const url = `js/article-registry.json?v=${timestamp}&r=${random}`;
        console.log('Fetching articles from:', url);
        
        const response = await fetch(url, {
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'Expires': '0'
            }
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const articles = await response.json();
        console.log('Loaded articles:', articles);
        
        if (!articles || !articles.length) {
            grid.innerHTML = '<div class="error">No articles found</div>';
            return;
        }

        // Initial load of all articles
        const articleCards = articles.map(createArticleCard).join('');
        grid.innerHTML = articleCards;

        // Set up filter buttons
        const filterButtons = document.querySelectorAll('.filter-btn');
        filterButtons.forEach(button => {
            button.addEventListener('click', function() {
                // Update active state
                filterButtons.forEach(btn => btn.classList.remove('active'));
                this.classList.add('active');

                // Filter articles
                const category = this.dataset.filter;
                const filteredArticles = filterArticles(articles, category);
                grid.innerHTML = filteredArticles.map(createArticleCard).join('');
            });
        });
    } catch (error) {
        console.error('Error loading articles:', error);
        grid.innerHTML = '<div class="error">Error loading articles. Please try again later.</div>';
    }
}

// Load articles when the DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadArticles);
} else {
    loadArticles();
} 